/**
 * Grid of organisation cards.
 *
 * Extracted from OrganisationManagementPage.tsx (Sub-PR 6.3).
 */

import { useTranslation } from 'react-i18next'
import type { Organisation } from '../../types'
import { OrganisationCard } from './OrganisationCard'

interface OrganisationGridProps {
  organisations: Organisation[]
  actionMenuOrg: string | null
  setActionMenuOrg: (id: string | null) => void
  onEdit: (org: Organisation) => void
  onDelete: (org: Organisation) => void
  onToggleStatus: (org: Organisation) => void
}

export function OrganisationGrid({
  organisations,
  actionMenuOrg,
  setActionMenuOrg,
  onEdit,
  onDelete,
  onToggleStatus,
}: OrganisationGridProps): React.ReactElement {
  const { t } = useTranslation('admin')
  if (organisations.length === 0) {
    return (
      <div className="rounded-lg border border-stone-200 bg-white p-8 text-center text-stone-500 dark:border-stone-700 dark:bg-stone-800 dark:text-stone-400">
        {t('organisations.noOrganisationsFound')}
      </div>
    )
  }
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {organisations.map((org) => (
        <OrganisationCard
          key={org.id}
          org={org}
          isMenuOpen={actionMenuOrg === org.id}
          onToggleMenu={() => {
            setActionMenuOrg(actionMenuOrg === org.id ? null : org.id)
          }}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleStatus={onToggleStatus}
        />
      ))}
    </div>
  )
}
